import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class CommodityService {
    constructor(http) {
        this.http = http;
        this.singular = 'commodity';
        this.plural = 'commodities';
        this.editor = PLATFORM.moduleName('pages/system-fields/commodities/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`commodities/filter/${loadOptions}`);
        return await response.json();
    }

    async create(commodity) {
        await this.http.fetch('commodities', { method: 'POST', body: json(commodity) });
    }

    async update(commodity) {
        await this.http.fetch(`commodities/${commodity.id}`, { method: 'PUT', body: json(commodity) });
    }

    async delete(id) {
        await this.http.fetch(`commodities/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`commodities/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`commodities/top-three/${query}`);
        return await response.json();
    }
}